import { Button, Snackbar, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";

const useStyles = makeStyles(
  theme => ({
    disabledTextfield: {
      "& .MuiInputBase-root": {
        "& .MuiButton-root": {
          "& span": {
            color: theme.palette.grey[400]
          }
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#EAEAEA"
        },
        backgroundColor: "#EFF5F8",
        borderColor: "#EAEAEA",
        pointerEvents: "none"
      }
    }
  }),
  { name: "Clipboard" }
);

export interface ClipboardProps {
  idClipboard?: string;
  label: string;
  value: string;
  onGenerate: () => void;
  disabled?: boolean;
}

const showDelay = 3000;

const Clipboard: React.FC<ClipboardProps> = ({
  label,
  idClipboard,
  value,
  onGenerate,
  disabled
}) => {
  const classes = useStyles("");

  const [openSnackbar, setOpenSnackbar] = useState(false);

  const handleClick = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      setOpenSnackbar(true);
    } else {
      onGenerate();
    }
  };

  return (
    <div>
      <TextField
        id={`${idClipboard}Txt`}
        fullWidth
        label={label}
        value={value || ""}
        InputProps={{
          endAdornment: (
            <Button
              color="primary"
              onClick={handleClick}
              disabled={disabled}
              id={
                idClipboard
                  ? `${idClipboard}${value ? "CopyBtn" : "GenerateBtn"}`
                  : null
              }
            >
              {value ? "Copy" : "Generate"}
            </Button>
          )
        }}
        className={disabled ? classes.disabledTextfield : ""}
      />
      <Snackbar
        id="clipboardPopUp"
        open={openSnackbar}
        autoHideDuration={showDelay}
        onClose={() => setOpenSnackbar(false)}
        message="Copied to clipboard!"
        key="topcenter"
      />
    </div>
  );
};

export default Clipboard;
